<template>
<div>
    <div class="position"></div>
    <van-tabbar v-model="activeName" active-color="#F34740" inactive-color="#999999">
        <van-tabbar-item v-for="(item,index) in list" :key="index" :name="item.name" replace :to="item.path">
            <span class="title">{{item.title}}</span>
            <template #icon="props">
                <img class="icon" :src="props.active ? item.active : item.inactive" />
            </template>
        </van-tabbar-item>
    </van-tabbar>
</div>
   
</template>

<script>
export default {
    props:["active"],
    data() {
        return {
           list:[
                {title:"首页",name:"index",path:"/",active:require("@/assets/icons/shouye.png"),inactive:require("@/assets/icons/shouye2.png")},
                {title:"产品库",name:"product",path:"/productList",active:require("@/assets/icons/chanpin.png"),inactive:require("@/assets/icons/chanpin2.png")},
                {title:"我的",name:"my",path:"/myInfo",active:require("@/assets/icons/wode.png"),inactive:require("@/assets/icons/wode2.png")}
           ]
        };
    },
    computed:{
        activeName:{
            get(){
                return this.active;
            },
            set(newValue){
                return newValue
            }
            
        }
    },
}
</script>

<style scoped>
    .position{
        width:100%;
        height:50px;
    }
    .title{
        font-size: 12px;
    }
    .icon{
        width:21px;
        height: 21px;
    }
    .van-tabbar{
        border-top: 2px solid #ECECEC;
    }
</style>


// WEBPACK FOOTER //
// src/components/tabbar.vue